import { EventTypes } from 'redux-segment';

import { aTypeInitCheckoutData } from 'actions/shared.types';
import asArray from 'utils/arrays/asArray.util';
import logger from 'utils/logger.util';

import { getAppointment } from 'checkout/actions';
import { APPOINTMENT_FAILURE, APPOINTMENT_SUCCESS } from 'checkout/constants';

const L = logger('setupCheckout');

const setupCheckout = (initData, salonId, appointmentId, allProceduresForTheDay, view, appointment) => {
  if (initData && !initData.appointment) initData.appointment = appointment;

  return (dispatch, getState) =>
    void dispatch(getAppointment(salonId, appointmentId))
      .catch((e) => void L.warn('() > getAppointment() > catch()', e))
      .then((r) => {
        L.debug('() > getAppointment() > then()', r);

        // FIXME: this data is ignored by the code

        if (r?.type !== APPOINTMENT_SUCCESS) return { type: APPOINTMENT_FAILURE };

        dispatch({
          type: aTypeInitCheckoutData.name,
          initData,
          registeredServices: asArray(getState().currentSalon?.services).reduce((array, category) => array.concat(category.services), []),
          proceduresInAppointment: r?.response?.procedures,
          allProceduresForTheDay,
          finishUrl: `/salon/${salonId}/${view}/checkout/complete`,
          meta: { analytics: EventTypes.track },
        });
      });
};

export default setupCheckout;
